import { ConfigurationFile } from "@anecdotes/configuration-data-access";

export const isRedirectToSignIn = (url: string, config: ConfigurationFile): boolean => {
  return config.auth.crossDomainSignIn && url.startsWith('auth/sign-in');
};
